"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var PathChangeListener = function () {
    var location = (0, react_router_dom_1.useLocation)();
    var prevPathName = (0, react_1.useRef)(location.pathname);
    var isNavigated = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        if (prevPathName.current === location.pathname && !isNavigated.current) {
            return;
        }
        var element = document.body;
        var customEvent = new CustomEvent('path-change', { detail: { path: location.pathname } });
        element.dispatchEvent(customEvent);
        isNavigated.current = true;
    }, [location.pathname]);
    return null;
};
exports.default = PathChangeListener;
